import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group row col-lg-8 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label" }, "Locale ID", -1)
const _hoisted_3 = { class: "input-group col-lg-10" }
const _hoisted_4 = { class: "col-9" }
const _hoisted_5 = { class: "col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!
  const _component_app_table = _resolveComponent("app-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_card, {
      label: "Function",
      classes: "pb-0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_app_input, {
                modelValue: _ctx.query.criteria,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.criteria) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_app_button, {
                theme: "info",
                icon: "fa-search",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.fetchList(0)), ["prevent"]))
              })
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_app_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_app_table, {
          rows: _ctx.list,
          total: _ctx.total,
          offset: _ctx.query.offset,
          limit: _ctx.query.limit,
          columns: _ctx.table.columns,
          actions: _ctx.table.actions,
          onRefreshData: _ctx.fetchList
        }, null, 8, ["rows", "total", "offset", "limit", "columns", "actions", "onRefreshData"])
      ]),
      _: 1
    })
  ], 64))
}